"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[806],{

/***/ 806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yJ": function() { return /* reexport */ landingpage_BottomNavigationIcon; },
  "Lc": function() { return /* reexport */ COR_js; },
  "CS": function() { return /* reexport */ landingpage_CS; },
  "dm": function() { return /* reexport */ landingpage_IFF; },
  "M9": function() { return /* reexport */ landingpage_MainContent; },
  "wp": function() { return /* reexport */ navbar; },
  "ON": function() { return /* reexport */ landingpage_ON; },
  "SC": function() { return /* reexport */ landingpage_SC; },
  "ZF": function() { return /* reexport */ landingpage_WCU; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 12 modules
var es = __webpack_require__(1894);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./parts/landingpage/navbar/index.js
/* eslint-disable no-empty-pattern */ /* eslint-disable @next/next/no-html-link-for-pages */ /* eslint-disable @next/next/no-img-element */ /* eslint-disable no-prototype-builtins */ /* eslint-disable no-unused-vars */ 




function Navbar(param) {
    var data = param.data, changeLanguage = param.changeLanguage, language = param.language;
    var idFreeConsultation = 20;
    var idCourier = 2;
    var idInternational = 7;
    var idEmail = 22;
    var handleClickFreeConsul = function(url) {
        window.open(url, "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                locale: language === "ID" ? "id" : "en",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: data === null || data === void 0 ? void 0 : data.logo,
                        alt: data === null || data === void 0 ? void 0 : data.alt_logo,
                        // layout="fill"
                        width: 125,
                        height: 62
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "top-nav-menu",
                children: (data === null || data === void 0 ? void 0 : data.HeaderMenus) !== undefined && (data === null || data === void 0 ? void 0 : data.HeaderMenus.map(function(item, index) {
                    return item.id !== idFreeConsultation && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: item.hasOwnProperty("child") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "link-sub-nav",
                                        children: language === "ID" ? item.id_menu_name : item.en_menu_name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "sub-nav-content",
                                        children: item.child.map(function(child, childIndex) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        child.hasOwnProperty("id_url") || child.hasOwnProperty("en_url") ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: language === "ID" ? "/" + (child === null || child === void 0 ? void 0 : child.id_url) : "/" + (child === null || child === void 0 ? void 0 : child.en_url),
                                                            locale: language === "ID" ? "id" : "en",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                        }),
                                                        child.hasOwnProperty("child") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                className: "subs-nav",
                                                                children: child.child.map(function(childofchild, childofchildIndex) {
                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: (child === null || child === void 0 ? void 0 : child.id) === idCourier ? "/courier-services/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url) : child.id === idInternational ? "/international-delivery/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url) : "/supply-chain/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url),
                                                                                locale: language === "ID" ? "id" : "en",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    children: language === "ID" ? childofchild.id_menu_name : childofchild.en_menu_name
                                                                                })
                                                                            })
                                                                        }, childofchildIndex)
                                                                    });
                                                                })
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                    ]
                                                }, childIndex)
                                            });
                                        })
                                    })
                                ]
                            }, index)
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: language === "ID" ? "/" + (item === null || item === void 0 ? void 0 : item.id_url) : "/" + (item === null || item === void 0 ? void 0 : item.en_url),
                                    locale: language === "ID" ? "id" : "en",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: language === "ID" ? item.id_menu_name : item.en_menu_name
                                    })
                                })
                            })
                        })
                    });
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "right",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "top-nav-menu top-consultation",
                        children: (data === null || data === void 0 ? void 0 : data.HeaderMenus) !== undefined && (data === null || data === void 0 ? void 0 : data.HeaderMenus.map(function(item, index) {
                            return item.id === idFreeConsultation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "link-sub-nav",
                                        children: language === "EN" ? item.en_menu_name : item.id_menu_name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "sub-nav-content",
                                        children: item.child.map(function(child, childIndex) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: (child === null || child === void 0 ? void 0 : child.id) === idEmail ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: language === "ID" ? "/" + (child === null || child === void 0 ? void 0 : child.id_url) : "/" + (child === null || child === void 0 ? void 0 : child.en_url),
                                                        locale: language === "ID" ? "id" : "en",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                        })
                                                    })
                                                }, childIndex) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    onClick: function() {
                                                        return handleClickFreeConsul(language === "EN" ? child.en_url : child.id_url);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "link-sub-nav",
                                                        children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                    })
                                                }, childIndex)
                                            });
                                        })
                                    })
                                ]
                            }, index);
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "top-nav-menu",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "".concat("https://cklnext.lyrid.id/", "/assets/icons/globe.png"),
                                            width: 30,
                                            height: 30,
                                            alt: "img"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-language",
                                            children: language
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "sub-nav-content",
                                    children: [
                                        language === "ID" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: changeLanguage,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "EN"
                                            })
                                        }),
                                        language === "EN" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: changeLanguage,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "ID"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "home",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "".concat("https://cklnext.lyrid.id/", "/assets/icons/home.png"),
                            width: 39,
                            height: 30,
                            alt: "home"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var navbar = (Navbar);

;// CONCATENATED MODULE: ./parts/landingpage/BottomNavigationIcon/index.js
/* eslint-disable @next/next/no-img-element */ /* eslint-disable react/prop-types */ // import Image from "next/image";



function BottomNavigationIcon(param) {
    var id = param.id, title = param.title, icon = param.icon, alt_icon = param.alt_icon, onHover = param.onHover;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: id === 3 ? "tablinks tablinks-international" : "tablinks",
        onMouseOver: onHover,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-img",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: icon,
                    alt: alt_icon,
                    width: 80,
                    height: 80
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-4",
                dangerouslySetInnerHTML: {
                    __html: title
                }
            })
        ]
    });
}
/* harmony default export */ var landingpage_BottomNavigationIcon = (BottomNavigationIcon);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
;// CONCATENATED MODULE: ./parts/landingpage/MainContent/index.js
/* eslint-disable react/prop-types */ 






var dataBottomNavigation = [
    {
        id: 1,
        name: "why"
    },
    {
        id: 2,
        name: "courier"
    },
    {
        id: 3,
        name: "international"
    },
    {
        id: 4,
        name: "supply"
    },
    {
        id: 5,
        name: "network"
    },
    {
        id: 6,
        name: "chat"
    }
];
function MainContent(param) {
    var _data = param.data, data = _data === void 0 ? [] : _data, CoverageArea = param.CoverageArea, language = param.language;
    var openCity = function openCity(evt, cityName, bg, alt) {
        var i, tabcontent_menu_ckl, tablinks;
        // ambil background default (background image yang bukan dari navigasi)
        var tagA = document.querySelectorAll("#stage a");
        tagA === null || tagA === void 0 ? void 0 : tagA.forEach(function(item) {
            item.style.display = "none";
        });
        tabcontent_menu_ckl = document.getElementsByClassName("tabcontent_menu_ckl");
        for(i = 0; i < tabcontent_menu_ckl.length; i++){
            tabcontent_menu_ckl[i].style.display = "none";
        }
        tablinks = document.getElementsByClassName("tablinks");
        for(i = 0; i < tablinks.length; i++){
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
        document.getElementById(cityName).style.display = "block";
        document.getElementById(cityName).style.backgroundImage = "url('".concat(bg, "')");
        // set atribut alt img
        document.getElementById(cityName).alt = alt;
        evt.currentTarget.className += " active";
    };
    var ref = (0,react.useState)([]), newData = ref[0], setNewData = ref[1];
    (0,react.useEffect)(function() {
        var result = [];
        data === null || data === void 0 ? void 0 : data.map(function(item) {
            dataBottomNavigation.map(function(nav) {
                if (item.id === nav.id) {
                    var obj = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        name: nav.name
                    });
                    result.push(obj);
                }
            });
        });
        setNewData(result);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "main-canvas",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "main-content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(landingpage_WCU, {
                    data: data[0],
                    language: language
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(landingpage_CS, {
                    data: data[1],
                    language: language
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(landingpage_IFF, {
                    data: data[2],
                    language: language
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(landingpage_SC, {
                    data: data[3],
                    language: language
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(landingpage_ON, {
                    data: CoverageArea,
                    language: language
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(COR_js, {
                    data: data[5],
                    language: language
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tab-menu-icon-ckl",
                    children: newData === null || newData === void 0 ? void 0 : newData.map(function(item, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(landingpage_BottomNavigationIcon, {
                            id: item === null || item === void 0 ? void 0 : item.id,
                            alt_icon: item === null || item === void 0 ? void 0 : item.alt_icon_img,
                            icon: item === null || item === void 0 ? void 0 : item.icon_img,
                            title: language === "EN" ? item.en_name : item.id_name,
                            onHover: function(e) {
                                return openCity(e, item.name, item.background_img, item.alt_background_img);
                            }
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "clearfix"
                })
            ]
        })
    });
}
/* harmony default export */ var landingpage_MainContent = (MainContent);

;// CONCATENATED MODULE: ./parts/landingpage/COR.js/index.js
/* eslint-disable @next/next/no-img-element */ /* eslint-disable react/prop-types */ 


// import WA from "../../../public/assets/icons/icon-whatsapp.png";
function COR(param) {
    var data = param.data, language = param.language;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var handleClick = function(url) {
        window.open("https://wa.me/".concat(url, "?text="), "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "chat",
            className: "tabcontent_menu_ckl page-nav-tabs-chat",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-overlay"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-content-chat",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                style: {
                                    color: "#ffffff",
                                    fontSize: "20px",
                                    fontWeight: "600",
                                    lineHeight: "1.4",
                                    letterSpacing: "0.42px",
                                    textAlign: "center",
                                    fontFamily: "IBM Plex Sans, sans-serif",
                                    transition: "transform 0.5s ease",
                                    marginBottom: "15px"
                                },
                                dangerouslySetInnerHTML: {
                                    __html: language === "EN" ? data === null || data === void 0 ? void 0 : (ref = data.content) === null || ref === void 0 ? void 0 : ref.en_desc : data === null || data === void 0 ? void 0 : (ref1 = data.content) === null || ref1 === void 0 ? void 0 : ref1.id_desc
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-btn-talk",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "btn-talk",
                                        onClick: function() {
                                            var ref;
                                            return handleClick(data === null || data === void 0 ? void 0 : (ref = data.content) === null || ref === void 0 ? void 0 : ref.wa_no1);
                                        },
                                        type: "button",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "".concat("https://cklnext.lyrid.id/", "/assets/icons/icon-whatsapp.png"),
                                                alt: "icon",
                                                width: 550,
                                                height: 30
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                dangerouslySetInnerHTML: {
                                                    __html: language === "EN" ? data === null || data === void 0 ? void 0 : (ref2 = data.content) === null || ref2 === void 0 ? void 0 : ref2.en_wa_btn_name1 : data === null || data === void 0 ? void 0 : (ref3 = data.content) === null || ref3 === void 0 ? void 0 : ref3.id_wa_btn_name1
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "btn-talk",
                                        onClick: function() {
                                            var ref;
                                            return handleClick(data === null || data === void 0 ? void 0 : (ref = data.content) === null || ref === void 0 ? void 0 : ref.wa_no2);
                                        },
                                        type: "button",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "".concat("https://cklnext.lyrid.id/", "/assets/icons/icon-whatsapp.png"),
                                                alt: "icon",
                                                width: 550,
                                                height: 30
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                dangerouslySetInnerHTML: {
                                                    __html: language === "EN" ? data === null || data === void 0 ? void 0 : (ref4 = data.content) === null || ref4 === void 0 ? void 0 : ref4.en_wa_btn_name2 : data === null || data === void 0 ? void 0 : (ref5 = data.content) === null || ref5 === void 0 ? void 0 : ref5.id_wa_btn_name2
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var COR_js = (COR);

;// CONCATENATED MODULE: ./parts/landingpage/CS/index.js
/* eslint-disable */ /* eslint-disable react/prop-types */ 



function CS(param) {
    var data = param.data, language = param.language;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "courier",
            className: "tabcontent_menu_ckl page-nav-tabs-courier-services",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-overlay"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-content-courier-services",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                dangerouslySetInnerHTML: {
                                    __html: language === "EN" ? data === null || data === void 0 ? void 0 : (ref = data.content) === null || ref === void 0 ? void 0 : ref.en_title : data === null || data === void 0 ? void 0 : (ref1 = data.content) === null || ref1 === void 0 ? void 0 : ref1.id_title
                                }
                            }),
                            (data === null || data === void 0 ? void 0 : (ref2 = data.nav_menu_icon) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? data === null || data === void 0 ? void 0 : (ref3 = data.nav_menu_icon) === null || ref3 === void 0 ? void 0 : ref3.map(function(item, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("button", {
                                    className: "btn-content-courier-services",
                                    // onClick={() => handleClick(item.url)}
                                    type: "button",
                                    children: item.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: item.url,
                                        locale: language === "ID" ? "id" : "en",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: item === null || item === void 0 ? void 0 : item.icon_img,
                                                    alt: item === null || item === void 0 ? void 0 : item.alt_icon_img,
                                                    width: 550,
                                                    height: 90
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: language === "EN" ? item === null || item === void 0 ? void 0 : item.en_title : item === null || item === void 0 ? void 0 : item.id_title
                                                    }
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: item === null || item === void 0 ? void 0 : item.icon_img,
                                                alt: item === null || item === void 0 ? void 0 : item.alt_icon_img,
                                                width: 550,
                                                height: 90
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                dangerouslySetInnerHTML: {
                                                    __html: language === "EN" ? item === null || item === void 0 ? void 0 : item.en_title : item === null || item === void 0 ? void 0 : item.id_title
                                                }
                                            })
                                        ]
                                    })
                                }, index);
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var landingpage_CS = (CS);

;// CONCATENATED MODULE: ./parts/landingpage/IFF/index.js
/* eslint-disable @next/next/no-img-element */ /* eslint-disable react/prop-types */ 



// import WA from "../../../public/assets/icons/icon-whatsapp.png";
function IFF(param) {
    var data = param.data, language = param.language;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var handleClick = function(url) {
        window.open("https://wa.me/".concat(url, "?text="), "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "international",
            className: "tabcontent_menu_ckl page-nav-tabs-international",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-overlay"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-content-international",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-box-for-iff",
                            children: [
                                (data === null || data === void 0 ? void 0 : (ref = data.nav_menu_icon) === null || ref === void 0 ? void 0 : ref.length) > 0 ? data === null || data === void 0 ? void 0 : (ref1 = data.nav_menu_icon) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("button", {
                                        className: "btn-content-international",
                                        // onClick={() => handleProduct(item?.url)}
                                        type: "button",
                                        children: item.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: item.url,
                                            locale: language === "ID" ? "id" : "en",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: item === null || item === void 0 ? void 0 : item.icon_img,
                                                        alt: item === null || item === void 0 ? void 0 : item.alt_icon_img,
                                                        width: 550,
                                                        height: 90
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: language === "EN" ? item.en_title : item.id_title
                                                        }
                                                    })
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: item === null || item === void 0 ? void 0 : item.icon_img,
                                                    alt: item === null || item === void 0 ? void 0 : item.alt_icon_img,
                                                    width: 550,
                                                    height: 90
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: language === "EN" ? item.en_title : item.id_title
                                                    }
                                                })
                                            ]
                                        })
                                    }, index);
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-btn-talk",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "btn-talk",
                                            onClick: function() {
                                                var ref;
                                                return handleClick(data === null || data === void 0 ? void 0 : (ref = data.content) === null || ref === void 0 ? void 0 : ref.wa_no1);
                                            },
                                            type: "button",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "".concat("https://cklnext.lyrid.id/", "/assets/icons/icon-whatsapp.png"),
                                                    alt: "icon",
                                                    width: 26,
                                                    height: 26
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: language === "EN" ? data === null || data === void 0 ? void 0 : (ref2 = data.content) === null || ref2 === void 0 ? void 0 : ref2.en_wa_btn_name1 : data === null || data === void 0 ? void 0 : (ref3 = data.content) === null || ref3 === void 0 ? void 0 : ref3.id_wa_btn_name1
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "btn-talk",
                                            onClick: function() {
                                                var ref;
                                                return handleClick(data === null || data === void 0 ? void 0 : (ref = data.content) === null || ref === void 0 ? void 0 : ref.wa_no2);
                                            },
                                            type: "button",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "".concat("https://cklnext.lyrid.id/", "/assets/icons/icon-whatsapp.png"),
                                                    alt: "icon",
                                                    width: 26,
                                                    height: 26
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: language === "EN" ? data === null || data === void 0 ? void 0 : (ref4 = data.content) === null || ref4 === void 0 ? void 0 : ref4.en_wa_btn_name2 : data === null || data === void 0 ? void 0 : (ref5 = data.content) === null || ref5 === void 0 ? void 0 : ref5.id_wa_btn_name2
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var landingpage_IFF = (IFF);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./parts/landingpage/ON/index.js
/* eslint-disable no-unused-vars */ 

// import { VectorMap } from 'react-jvectormap';


function ON(param) {
    var data = param.data, language = param.language;
    var getWindowSize = function getWindowSize() {
        if (true) {
            var ref = "object" !== "undefined", innerWidth = ref.innerWidth, innerHeight = ref.innerHeight;
            return {
                innerWidth: innerWidth,
                innerHeight: innerHeight
            };
        }
    };
    var VectorMap = dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 70).then(__webpack_require__.t.bind(__webpack_require__, 4608, 23)).then(function(m) {
            return m.VectorMap;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(4608)
                ];
            }
        },
        ssr: false
    });
    // useEffect(() => {
    //   document.querySelectorAll('g').forEach((element) => {
    //     element.class = "tes";
    //   });
    // }, [])
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(getWindowSize()), windowSize = ref[0], setWindowSize = ref[1];
    var showInfo = function() {
        var elems = Array.from(document.querySelectorAll(".jvectormap-tip"));
        elems.pop();
        elems.map(function(node) {
            return node.parentNode.removeChild(node);
        });
        document.querySelectorAll(".jvectormap-tip").forEach(function(element) {
            element.style.display = "block";
        });
    };
    var hideInfo = function() {
        document.querySelectorAll(".jvectormap-tip").forEach(function(element) {
            element.style.display = "none";
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "network",
            className: "tabcontent_menu_ckl page-nav-tabs-our-network",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-overlay"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-content-our-network",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "box-our-network",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VectorMap, {
                                        map: "indonesia",
                                        selectedRegions: data,
                                        onRegionClick: function(e, countryCode) {
                                            return e.preventDefault();
                                        },
                                        backgroundColor: "transparent",
                                        zoomOnScroll: false,
                                        zoomButtons: false,
                                        // containerStyle={{
                                        //   width: '955px',
                                        //   height: '400px',
                                        //   borderRadius: '10px',
                                        //   margin: '0px auto',
                                        //   paddingLeft: '15px',
                                        // }}
                                        onRegionOver: function(e, code) {
                                            showInfo();
                                        },
                                        onRegionOut: function(e, code) {
                                            hideInfo();
                                        },
                                        // containerClassName='map'
                                        regionStyle: {
                                            initial: {
                                                fill: "white",
                                                "fill-opacity": 1,
                                                stroke: "none",
                                                "stroke-width": 0,
                                                "stroke-opacity": 1
                                            },
                                            hover: {
                                                "fill-opacity": 0.8,
                                                cursor: "pointer"
                                            },
                                            selected: {
                                                fill: "yellow"
                                            }
                                        }
                                    })
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var landingpage_ON = (ON);

;// CONCATENATED MODULE: ./parts/landingpage/SC/index.js
/* eslint-disable */ /* eslint-disable react/prop-types */ 



function SC(param) {
    var data = param.data, language = param.language;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var handleClick = function(url) {
        window.open(url, "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "supply",
            className: "tabcontent_menu_ckl page-nav-tabs-supply",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-overlay"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-content-supply",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-box-for-sc",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    dangerouslySetInnerHTML: {
                                        __html: language === "EN" ? data === null || data === void 0 ? void 0 : (ref = data.content) === null || ref === void 0 ? void 0 : ref.en_title : data === null || data === void 0 ? void 0 : (ref1 = data.content) === null || ref1 === void 0 ? void 0 : ref1.id_title
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: language === "EN" ? data === null || data === void 0 ? void 0 : (ref2 = data.content) === null || ref2 === void 0 ? void 0 : ref2.en_desc : data === null || data === void 0 ? void 0 : (ref3 = data.content) === null || ref3 === void 0 ? void 0 : ref3.id_desc
                                    }
                                }),
                                (data === null || data === void 0 ? void 0 : (ref4 = data.nav_menu_icon) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 ? data === null || data === void 0 ? void 0 : (ref5 = data.nav_menu_icon) === null || ref5 === void 0 ? void 0 : ref5.map(function(item, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("button", {
                                        className: "btn-content-supply",
                                        // onClick={() => handleClick(item.url)}
                                        type: "button",
                                        children: item.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: item.url,
                                            locale: language === "ID" ? "id" : "en",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: item === null || item === void 0 ? void 0 : item.icon_img,
                                                        alt: item === null || item === void 0 ? void 0 : item.alt_icon_img,
                                                        height: 90,
                                                        width: 90
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: language === "EN" ? item === null || item === void 0 ? void 0 : item.en_title : item === null || item === void 0 ? void 0 : item.id_title
                                                        }
                                                    })
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: item === null || item === void 0 ? void 0 : item.icon_img,
                                                    alt: item === null || item === void 0 ? void 0 : item.alt_icon_img,
                                                    width: 550,
                                                    height: 90
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: language === "EN" ? item === null || item === void 0 ? void 0 : item.en_title : item === null || item === void 0 ? void 0 : item.id_title
                                                    }
                                                })
                                            ]
                                        })
                                    }, index);
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            ]
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var landingpage_SC = (SC);

;// CONCATENATED MODULE: ./parts/landingpage/WCU/index.js
/* eslint-disable */ /* eslint-disable react/prop-types */ 


function WCU(param) {
    var data = param.data, language = param.language;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "why",
            className: "tabcontent_menu_ckl page-nav-tabs-why-choose-us",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-overlay"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-content-why-choose-us",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-box-why-choose-us",
                            children: (data === null || data === void 0 ? void 0 : (ref = data.nav_menu_icon) === null || ref === void 0 ? void 0 : ref.length) > 0 ? data === null || data === void 0 ? void 0 : (ref1 = data.nav_menu_icon) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("button", {
                                    className: "btn-content-why-choose-us",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: item === null || item === void 0 ? void 0 : item.icon_img,
                                            alt: item === null || item === void 0 ? void 0 : item.alt_icon_img,
                                            height: 40,
                                            width: 60
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            dangerouslySetInnerHTML: {
                                                __html: language === "EN" ? item.en_title : item.id_title
                                            }
                                        })
                                    ]
                                }, index);
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var landingpage_WCU = (WCU);

;// CONCATENATED MODULE: ./parts/landingpage/index.js












/***/ })

}]);